<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :hot-key-create-path="'/sales-contract/create'"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Sales Contract"
        :baseView="baseView"
        primaryLabel="Sales Contract #"
        :secondaryLabel="baseView.id"
      />
    </template>
    <GcAccountStatusModal
      v-if="accountStatusPopupVisible"
      :parent-model="model"
      :show-modal.sync="accountStatusPopupVisible"
      @close-form="onCloseGenerateModal"
      @show-loading="showLoadingHelper"
    />

    <div v-show="selectedIndex == 0" class="css-v2 transaction-screen">
      <div class="gc-header-form">
        <div class="gc-form-header-toolbar">
          <DxToolbar
            class="view-toolbar form-header-toolbar"
            ref="toolbar-header"
          >
            <DxItem #default location="after" locate-in-menu="auto">
              <gc-status-chip :status="statusFreindly" />
            </DxItem>
            <DxItem
              widget="dxForm"
              location="before"
              :options="{
                formData: model,
                items: toolbarFormItems,
                validationGroup: formsConfig.validationGroup,
                labelLocation: 'left',
                disabled: baseView.mode == 'review' ? true : false,
                requiredMark: '',
              }"
              locate-in-menu="auto"
              :disabled="baseView.mode == 'review' ? true : false"
              ref="sales-contract-toolbar-form"
            ></DxItem>
            <DxItem
              :options="toolbar.notes"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
              :visible.sync="isEditVisible"
            />
            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
              :visible.sync="isEditVisible"
            />
            <DxItem
              :options="toolbar.headerActions"
              location="after"
              locate-in-menu="auto"
              widget="dxDropDownButton"
              ref="headerActionMenu"
              v-if="baseView.mode == 'review'"
            />
            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
              ref="headerSaveMenu"
            />
          </DxToolbar>
        </div>

        <GcGenerateSalesOrder
          v-if="generateSalesOrderPopupVisible"
          :parent-model="model"
          :parent-contract-lines.sync="
            customerSalesContractLineDataSourceConfig
          "
          :show-modal.sync="generateSalesOrderPopupVisible"
          @close-form="onCloseGenerateModal"
          @show-validation-errors="showGenerateSoValidationErrors"
          @show-server-errors="showServerErrors"
          @show-loading="showLoadingHelper"
        />

        <GcGenerateSalesOrderFromContractLine
          v-if="generateSalesOrderFromContractLinePopupVisible"
          :parent-model="model"
          :parent-contract-line.sync="selectedContractLine"
          :show-modal.sync="generateSalesOrderFromContractLinePopupVisible"
          @close-form="onCloseGenerateModal"
          @show-validation-errors="showGenerateSoValidationErrors"
          @show-server-errors="showServerErrors"
          @show-loading="showLoadingHelper"
        />
        <!-- </DxPopup> -->

        <DxPopup
          :visible.sync="lineCommentsPopupVisible"
          :drag-enabled="false"
          :hide-on-outside-click="true"
          :show-title="true"
          :title="lineCommentModel.Title"
          :width="550"
          :height="340"
          :showCloseButton="false"
        >
          <form>
            <DxForm
              :ref="'line-comments-form'"
              :customizeItem="customizeLineCommentItem"
              :form-data.sync="lineCommentModel"
              :items="lineCommentItems"
              :label-location="formsConfig.labelPosition"
            ></DxForm>
          </form>

          <div class="footer">
            <DxButton
              text="Back"
              type="default"
              styling-mode="contained"
              @click="popupLineCommentBackButtonClick"
            />
          </div>
        </DxPopup>
        <!-- Line item history popup  -->
        <DxPopup
          :visible.sync="lineItemHistoryPopupVisible"
          :drag-enabled="false"
          :hide-on-outside-click="true"
          :show-title="true"
          :title="lineItemHistoryModel.Title"
          :showCloseButton="false"
          :height="600"
          @hidden="itemHistoryPopupHidden"
        >
          <dx-data-grid
            class="dx-card wide-card"
            :data-source="lineItemHistoryModel.ItemHistoryDataSourceConfig"
            :show-borders="false"
            :focused-row-enabled="false"
            :column-auto-width="true"
            :column-hiding-enabled="false"
            :selection="{ mode: 'single' }"
            :hover-state-enabled="true"
            :height="440"
            :columns="lineItemHistoryColumns"
            :allow-column-reordering="false"
            :column-chooser="{ enabled: false }"
            ref="itemHistoryGrid"
          >
            <DxSearchPanel :visible="true" :highlight-case-sensitive="true" />
            <dx-paging :page-size="50" />
            <dx-pager :show-page-size-selector="true" :show-info="true" />
            <dx-filter-row :visible="false" />

            <!-- <template #date-created-cell-template="{ data }">
          <gc-friendly-date :date="data.data.DateCreated" />
        </template> -->
          </dx-data-grid>

          <div class="footer">
            <DxButton
              text="Back"
              type="default"
              styling-mode="contained"
              @click="popUpBackButtonClick"
            />
          </div>
        </DxPopup>
        <!-- Review Actions on a Contract Line popup  -->
        <DxPopup
          :visible.sync="notesPopupVisible"
          :hide-on-outside-click="true"
          :show-title="true"
          title="Order Notes"
          :width="750"
          :height="575"
          :showCloseButton="false"
          @hidden="onNotesPopupHidden"
        >
          <div>
            <dx-data-grid
              :ref="gridRefName"
              :data-source="orderNotesDataSourceConfig"
              :columns="columns"
              @toolbar-preparing="notesToolbarPreparing($event)"
              :height="416"
              :width="700"
              @rowRemoved="onRowDelete"
              @keyDown="onNotesCellKeyDown"
              @editor-preparing="setMaxLength($event)"
              @row-click="onRowClick($event)"
              :allow-column-reordering="false"
              :column-chooser="{ enabled: false }"
            >
              <DxEditing
                :allow-deleting="true"
                :allow-updating="false"
                mode="cell"
                newRowPosition="first"
              />
              <template #note-edit-template="{ data }">
                <DxTextArea
                  :maxLength="1000"
                  :value="data.value"
                  @value-changed="onValueChangedNoteKeyUp($event, data)"
                  @key-down="onNoteKeyUp"
                />
              </template>

              <template #note-template="{ data }">
                <div class="gc-so-note-template">
                  {{ data.data.Note }}
                  <!-- <DxButton :disabled="!deleteEnabled" icon="trash" @click="onDeleteClick(data)" /> -->
                </div>
              </template>

              <template #date-template="{ data }">
                <DxDateBox
                  :value="data.data.DateCreated"
                  :readOnly="true"
                  :display-format="'dd MMM yyyy'"
                />
              </template>

              <!-- <dx-paging :page-size="3" /> -->
            </dx-data-grid>

            <div class="footer">
              <DxButton
                text="Save"
                :disabled="!enableNotesSave"
                type="default"
                styling-mode="contained"
                style="float: left"
                @click="onPopupLineCommentSaveButtonClick"
              />
              <DxButton
                text="Cancel"
                type="default"
                styling-mode="contained"
                @click="onPopupLineCommentCancelButtonClick"
              />
            </div>
          </div>
        </DxPopup>
        <DxPopup
          :visible.sync="transactionHistoryPopupVisible"
          :drag-enabled="false"
          :hide-on-outside-click="true"
          :show-title="true"
          :title="transactionHistoryModel.Title"
          :showCloseButton="false"
          height="90%"
          width="92%"
          @hidden="transactionHistoryPopupHidden"
        >
          <gc-filter-split-view
            :showLeftContainer="showFilterLeftContainer"
            :showRightContainer="showFilterRightContainer"
          >
            <template #leftContent>
              <dx-data-grid
                class="dx-card wide-card"
                :data-source="
                  transactionHistoryModel.TransactionHistoryDataSourceConfig
                "
                :show-borders="false"
                :focused-row-enabled="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                :selection="{ mode: 'single' }"
                :hover-state-enabled="true"
                :height="gridHeight - 220"
                :columns="transactionHistoryColumns"
                @toolbar-preparing="onToolbarPreparingDrawdownHistory($event)"
                ref="transactionHistoryGrid"
                @content-ready="listContentReady"
                :allow-column-reordering="false"
                :element-attr="{ id: 'transaction-history-grid' }"
                @exporting="
                  onGridToExcelExporting(
                    $event,
                    `DrawdownList`,
                    transactionHistoryColumns
                  )
                "
              >
                <DxExport :enabled="true" />
                <DxSearchPanel
                  :visible="true"
                  :highlight-case-sensitive="true"
                />
                <dx-paging :page-size="50" />
                <dx-pager
                  :show-page-size-selector="true"
                  :show-info="true"
                  :visible="true"
                />
                <dx-filter-row :visible="false" />

                <!-- <template #date-created-cell-template="{ data }">
          <gc-friendly-date :date="data.data.DateCreated" />
        </template> -->
                <template #status-cell-template="{ data }">
                  <gc-status-chip :status="data.data.FriendlyStatus" />
                </template>
                <template #product-cell-template="{ data }">
                  <GcDescriptionCodeCellTemplate
                    :description="data.data.ItemDescription"
                    :code="data.data.ItemCode"
                  />
                </template>
                <template #customer-cell-template="{ data }">
                  <GcDescriptionCodeCellTemplate
                    :description="data.data.CustomerName"
                    :code="data.data.CustomerCode"
                  />
                </template>
              </dx-data-grid>

              <div class="footer">
                <DxButton
                  text="Back"
                  type="default"
                  styling-mode="contained"
                  @click="popUpBackButtonClick"
                />
              </div>
            </template>
            <template #rightContent>
              <gc-advance-filter-panel
                :toolbar="filterToolbar"
                :setFilterFormHeight="filterFormHeightDrawdown"
                :sideBarTabs="sideBarTabs"
                :filterFormItems="transactionHistoryFilterFormItems"
                :filterModel="getAdvanceFilterModelForDrawdown"
                :isJson="false"
                :screenType="'drawdown-list'"
                :data-source-config="
                  transactionHistoryModel.TransactionHistoryDataSourceConfig
                "
                :initial-filter="initialFilterDrawdown"
                v-if="
                  transactionHistoryModel.TransactionHistoryDataSourceConfig
                "
              >
              </gc-advance-filter-panel>
            </template>
          </gc-filter-split-view>
        </DxPopup>
        <div class="view-card responsive-paddings">
          <form>
            <DxForm
              :form-data="model"
              :read-only="false"
              :show-colon-after-label="false"
              :show-validation-summary="false"
              :validation-group="'headerFormsData'"
              :label-location="formsConfig.labelPosition"
              :customizeItem="customizeItem"
              :items="headerFormItems"
              :show-required-mark="false"
              ref="stock-transfer-header-form"
              @content-ready="onFormContentReady"
            >
              <template #agentTemplate="{ data }">
                <div class="toolbar-auto-complete">
                  <span class="title">{{ data.Name }}</span>
                  <span class="sub-title" style="color: grey">{{
                    data.Code
                  }}</span>
                </div>
              </template>
            </DxForm>
          </form>
        </div>
      </div>
      <div>
        <dx-data-grid
          v-if="loadingCompleted"
          class="dx-card wide-card"
          :data-source="customerSalesContractLineDataSourceConfig"
          :show-borders="false"
          :ref="'sales-contract-grid'"
          :focused-row-enabled="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          :selection="{ mode: 'single' }"
          :hover-state-enabled="true"
          :column-min-width="100"
          :reshape-on-push="true"
          :height="gridHeight - 260"
          @cell-prepared="onCellPrepared"
          @toolbar-preparing="onToolbarPreparing($event)"
          @initialized="stockTransferDetailsInitialized"
          :column-fixing-enabled="true"
          :columns="salesContractDetailsColumns"
          key-expr="Key"
          validation-group="formsData"
          @content-ready="addGridNoResults($event)"
          :column-chooser="{ enabled: false }"
        >
          <!-- :key-expr="['ItemCode', 'UnitOfMeasureCode']" -->
          <dx-paging :page-size="50" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />

          <DxSearchPanel :visible="true" :highlight-case-sensitive="true" />
          <DxEditing :allow-updating="true" mode="cell" />

          <template #qtyEditTemplate="{ data }">
            <div>
              <div>
                <DxNumberBox
                  :value="data.value"
                  @value-changed="lineQtyChanged($event, data)"
                  :disabled="baseView.mode == 'review'"
                  :format="getDecimalFormatByCode(7).Format"
                  class="gc-grid-number-box-editor"
                  :min="data.data.DrawnQuantity"
                  :max="999999999.99"
                />
              </div>
            </div>
          </template>
          <template #priceEditTemplate="{ data }">
            <div>
              <div>
                <DxNumberBox
                  :value="data.value"
                  @value-changed="defaultPriceChanged($event, data)"
                  :disabled="baseView.mode == 'review'"
                  :format="getDecimalFormatByCode(7).Format"
                  class="gc-grid-number-box-editor"
                  :min="0"
                  :max="999999999.99"
                />
              </div>
            </div>
          </template>
          <template #sales-um-template="{ data }">
            <div class="gc-auto-cmp">{{ data.data.SalesUM }}</div>
          </template>
          <template #salesUMEditTemplate="{ data: cellInfo }">
            <div class="gc-auto-cmp-editor">
              <GcSalesUmDropdown
                :ref="'salesUM' + cellInfo.rowIndex"
                :data-source="salesUMDs"
                :value="cellInfo.value"
                :cell-info="cellInfo"
                :sales-um-field="'Code'"
                :on-value-changed="salesUmValueChanged"
              />
            </div>
          </template>
          <template #contractDescriptionEditTemplate="{ data: cellInfo }">
            <DxSelectBox
              :ref="'contractDescription' + cellInfo.rowIndex"
              :items="contractDescriptions"
              :displayExpr="'Description'"
              :valueExpr="'RecordId'"
              :searchExpr="['Description']"
              :value.sync="cellInfo.value"
              :cell-info="cellInfo"
              @selection-changed="
                contractDescriptionCodeChanged($event, cellInfo)
              "
              :search-enabled="true"
              width="100%"
            >
              <DxDropDownOptions
                :hide-on-outside-click="true"
                :show-title="false"
                :minWidth="300"
              />
            </DxSelectBox>
          </template>
          <template #use-market-price-template="{ data }">
            <div>
              <DxCheckBox
                :value="data.data.UseMarket === 'Y'"
                @value-changed="useMarketValueChanged($event, data)"
                :readOnly="baseView.mode == 'review' ? true : false"
                :ref="'cb-' + ''"
              />
            </div>
          </template>
          <template #apply-freight-template="{ data }">
            <div>
              <DxCheckBox
                :value="data.data.ApplyFreight === 'Y'"
                @value-changed="applyFreightValueChanged($event, data)"
                :readOnly="baseView.mode == 'review' ? true : false"
                :ref="'cb-' + ''"
              />
            </div>
          </template>
          <template #UnitOfMeasureTemplate="{ data }">
            <div class="custom-auto-complete">
              <span class="auto-complete-primary">{{ data.Description }}</span>
              <span class="auto-complete-secondary">{{ data.Code }}</span>
            </div>
          </template>
          <template #menu-cell-template="{ data }">
            <DxDropDownButton
              :items="contractLineContextMenu.getMenuItems(data)"
              keyExpr="menuText"
              displayExpr="menuText"
              :drop-down-options="{ width: 250 }"
              class="gc-dropdown-icon-button"
              :id="data.data.Key"
              :icon="contractLineContextMenu.icon"
              styling-mode="text"
              :show-arrow-icon="false"
              :onItemClick="onContractLineContextMenuItemClick"
            />
          </template>

          <DxMasterDetail
            :enabled="loadingCompleted"
            template="masterDetailTemplate"
          />
          <template #masterDetailTemplate="{ data: lineitem }">
            <GcSalesContractProductDetails
              :template-data="lineitem"
              :parent-model="model"
              :update-review-list="updateReviewList"
              :brokenGridValidations="brokenGridValidations"
              :allow-edit="baseView.mode != 'review'"
              :more-menu-call-back="moreMenuCallBack"
            />
          </template>
        </dx-data-grid>
      </div>
    </div>
    <div v-show="selectedIndex == 1" class="css-v2 transaction-list">
      <gc-filter-split-view
        :showLeftContainer="showLeftContainerInvoicedList"
        :showRightContainer="showRightContainerInvoicedList"
      >
        <template #leftContent>
          <dx-data-grid
            class="dx-card wide-card"
            :data-source="salesContractsInvoicedOrdersList"
            :show-borders="false"
            :focused-row-enabled="false"
            :column-auto-width="true"
            :column-hiding-enabled="false"
            :selection="{ mode: 'single' }"
            :hover-state-enabled="true"
            :height="gridHeight - 20"
            :columns="salesContractsInvoicedOrdersListColumns"
            @toolbar-preparing="onToolbarPreparingInvoicedList($event)"
            :no-data-text="'This contract has no invoiced sales orders.'"
            ref="invoicedListGrid"
          >
            <DxExport
              :enabled="true"
              :file-name="'SalesContractInvoicedList'"
            />
            <DxSearchPanel :visible="true" :highlight-case-sensitive="true" />
            <dx-paging :page-size="50" />
            <dx-pager
              :show-page-size-selector="true"
              :show-info="true"
              :visible="true"
            />
            <dx-filter-row :visible="false" />
            <template #customer-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerName"
                :code="data.data.CustomerCode"
              />
            </template>
            <template #status-cell-template="{ data }">
              <gc-status-chip :status="data.data.FriendlyStatus" />
            </template>
            <template #menu-cell-template="{ data }">
              <DxButton icon="print" @click="onPrintClick(data)" />
            </template>
          </dx-data-grid>
        </template>
        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem #default location="before" locate-in-menu="never">
              <div class="toolbar-label">
                <span class="text-primary"> Filters </span>
              </div>
            </DxItem>

            <DxItem
              :options="invoicedListModel.toolbar.clear"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
            />

            <DxItem
              :options="invoicedListModel.toolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>
          <div class="view-card responsive-paddings">
            <DxScrollView
              id="filter-scrollview"
              :show-scrollbar="'always'"
              :scroll-by-content="true"
              :scroll-by-thumb="true"
              :height="filterFormHeight"
            >
              <form>
                <DxForm
                  :form-data.sync="invoicedListModel.model"
                  :show-colon-after-label="false"
                  :show-required-mark="false"
                  :show-validation-summary="false"
                  :validation-group="formsConfig.validationGroup"
                  :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                  label-location="top"
                  :items="invoicedListFilterFormItems"
                >
                  <template #filterCustomerTemplate="{ data }">
                    <div class="toolbar-auto-complete">
                      <span class="title">{{ data.Name }}</span>
                      <span class="sub-title" style="color: grey">{{
                        data.Code
                      }}</span>
                    </div>
                  </template>

                  <template #deliveryAddressTemplate="{ data }">
                    <div class="custom-auto-complete data-grid">
                      <span class="auto-complete-primary">
                        {{ data.CompanyName }}
                      </span>
                      <div class="auto-complete-secondary no-padding">
                        <span v-if="data.PhysicalAddressStreetLine1 != ''">
                          {{ data.PhysicalAddressStreetLine1 }}
                        </span>
                        <span v-if="data.PhysicalAddressStreetLine2 != ''">{{
                          data.PhysicalAddressStreetLine2
                        }}</span>
                        <span v-if="data.PhysicalAddressSuburb != ''">{{
                          data.PhysicalAddressSuburb
                        }}</span>
                        <span v-if="data.PhysicalAddressState != ''">{{
                          data.PhysicalAddressState
                        }}</span>
                        <span v-if="data.PhysicalAddressPostcode != ''">{{
                          data.PhysicalAddressPostcode
                        }}</span>
                      </div>
                    </div>
                  </template>
                </DxForm>
              </form>
            </DxScrollView>
          </div>
        </template>
      </gc-filter-split-view>
    </div>
  </gc-main-layout>
</template>
<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { DxMasterDetail, DxExport } from "devextreme-vue/data-grid";
import validationEngine from "devextreme/ui/validation_engine";
import { SalesOrderNoteService } from "../../_services/api/sales/sales-order-note.service";
import { CustomerSalesContractService } from "../../_services/api/accounts/customer-sales-contract.service";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { CustomerService } from "../../_services/api/customers/customer.service";

import { CustomerSalesContractListService } from "../../_services/api/sales/sales-contract-list.service";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
import { UnitOfMeasureService } from "../../_services/api/settings/products/unit-of-measure.service";
import ApiService from "../../_services/api/api.service";
import { FeatureStorage } from "../../_services/storage";
import { DxDropDownOptions } from "devextreme-vue/lookup";
import { CustomerSalesContractDescription } from "../../_services/api/customers/customer-sales-contract-description.service";

let currentContractLineKey = -1;
let stockTransferDetailsGridInstance = null;
let reviewModeSearchText = "";
let contractLineNextKey = 1;
let validationErrors = [];

var orderNotesDataSource = SalesOrderNoteService.dataSourceConfig({
  select: ["Note", "LineNo"],
  sort: [{ selector: "LineNo", asc: true }],
});

var customerDataSource = CustomerService.dataSourceConfig("api/Customer", {
  select: ["Code", "Name", "SalesRepresentativeCode", "CurrencyCode"],
  sort: [{ selector: "Name", asc: true }],
  top: 5,
  filter: ["Inactive", "=", "N"],
  count: true,
});

let unitOfMeasureDs = UnitOfMeasureService.dataSourceConfig(
  "api/UnitOfMeasure",
  {
    select: ["Code", "Description"],
    filter: ["Inactive", "=", false],
    sort: [{ selector: "Code", asc: true }],
  }
);

let baseLineRecord = {
  CustomerSalesContractCode: null,
  LineNo: null,
  CustomerSalesContractLineDescriptionRecordID: undefined,
  Description: "",
  SalesUM: "",
  Quantity: 0,
  DefaultPrice: 0,
  OldSalesUM: "",
  OldQuantity: 0,
  OldDefaultPrice: 0,
  UseMarket: "N",
  ApplyFreight: "N",
  RecordId: "00000000-0000-0000-0000-000000000000",
  DrawnQuantity: 0,
  CustomerSalesContractItemConsumptions: [],
  IsDirty: () => {
    this.Quantity !== this.OldQuantity;
  },
};

let customerSalesContractLineDataSource = CustomerSalesContractService.dataSourceConfig(
  "api/CustomerSalesContractLineConsumption",
  {
    postProcess: (data) => {
      contractLineNextKey = 1;
      data.forEach((row) => {
        row["Key"] = contractLineNextKey++;
        row["OldQuantity"] = row["Quantity"];
        row["OldDefaultPrice"] = row["DefaultPrice"];
        row["OldSalesUM"] = row["SalesUM"];
        row["IsDirty"] = false;
      });

      return data;
    },
    expand: "CustomerSalesContractItems,CustomerSalesContractItemConsumptions",
    preventPagination: true,
  }
);

let salesContractsInvoicedOrdersListDs = ApiService.createDataSource(
  "api/SalesContractsInvoicedOrdersList",
  {
    sort: [{ selector: "DateIn", desc: true }],
  }
);

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: {
    DxMasterDetail,
    DxExport,
    DxDropDownOptions,
  },

  data() {
    return {
      columns: [
        {
          caption: "Date Created",
          dataField: "DateCreated",
          width: 150,
          alignment: "left",
          allowEditing: false,
          format: "dd MMM yyyy",
          dataType: "date",
        },
        {
          caption: "Note",
          dataField: "Note",
          width: 400,
          alignment: "left",
          editCellTemplate: "note-edit-template",
          showEditorAlways: true,
          editorOptions: {
            maxLength: 1000,
          },
          validationRules: [
            {
              type: "required",
              message: "Note is required",
            },
          ],
        },
        {
          caption: "Created By",
          dataField: "CreatedBy",
          width: 150,
          alignment: "left",
          allowEditing: false,
        },
        {
          caption: "Date Changed",
          dataField: "DateChanged",
          width: 150,
          alignment: "left",

          allowEditing: false,
          format: "dd MMM yyyy",
          dataType: "date",
        },
        {
          caption: "Changed By",
          dataField: "ChangedBy",
          width: 150,
          alignment: "left",
          allowEditing: false,
          editorOptions: {
            maxLength: 1000,
          },
        },
      ],
      orderNotesDataSourceConfig: [],
      notePopupSaveButtonDisabled: true,
      // filterFormHeight: "500px",
      notesPopupVisible: false,
      saveFileName: "DrawdownList",
      showRightContainerInvoicedList: false,
      showLeftContainerInvoicedList: true,
      salesContractsInvoicedOrdersList: salesContractsInvoicedOrdersListDs,
      salesUMDs: [],
      contractDescriptions: [],
      contractDescriptionCode: "",
      gridRefName: "gridManifestOrder",
      brokenGridValidations: [],
      toolbar: {
        notes: {
          icon: "file",
          onClick: () => {
            this.notesPopupVisible = true;
            this.notePopupSaveButtonDisabled = true;
          },
        },
        edit: {
          icon: "edit",
          onClick: () => {
            this.$router.push({
              path: `/sales-contract/edit/${this.model.Code}`,
            });
          },
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: () => {
            this.$logger.trackEventButtonClickSave();
            this.saveSalesContract();
          },
        },
        headerActions: {
          icon: "more",
          class: "gc-dropdown-icon-button",
          stylingMode: "text",
          showArrowIcon: false,
          items: [
            { menuText: "Generate Order" },
            { menuText: "Account Status" },
          ],
          keyExpr: "menuText",
          displayExpr: "menuText",
          dropDownOptions: { width: 150 },

          onItemClick: (e) => {
            if (e.itemData.menuText == "Generate Order") {
              this.generateSalesOrderPopupVisible = true;
            } else if (e.itemData.menuText == "Account Status") {
              this.accountStatusPopupVisible = true;
            }
          },
        },
      },
      model: {
        Code: null,
        CustomerCode: null,
        Description: null,
        StartDate: new Date(),
        EndDate: null,
        Name: "",
        ParentCustomerSalesContractCode: null,
        Status: "A",
        Type: "Contract",
        CustomerSalesContractLines: [],

        // additional model props
        CompanyCode: "",
        BranchCode: "",
        DivisionCode: "",
        CurrencyCode: "",
      },
      customerSalesContractLineDataSourceConfig: [],

      contractLineContextMenu: {
        icon: "overflow",
        getMenuItems: (data) => {
          let menuItems = [];

          if (this.baseView.mode == "edit")
            menuItems.push({ menuText: "Delete Line", data: data });
          if (data.data.LineNo && data.data.LineNo > 0) {
            if (this.baseView.mode == "edit")
              menuItems.push({ menuText: "Edit Comment", data: data });
            menuItems.push({ menuText: "View History", data: data });
            if (
              this.baseView.mode == "review" &&
              data.data.CustomerSalesContractItemConsumptions.length > 0
            ) {
              if (this.model.Type != "Allocation") {
                menuItems.unshift({ menuText: "Generate Order", data: data });
              }
              menuItems.unshift({ menuText: "Drawdown", data: data });
            }
          }

          return menuItems;
        },
      },
      generateSalesOrderPopupVisible: false,
      salesContractCode: undefined,
      salesContractObj: undefined,
      generateSalesOrderFromContractLinePopupVisible: false,
      accountStatusPopupVisible: false,
      selectedContractLine: null,
      lineCommentsPopupVisible: false,
      lineCommentModel: {
        Comment: "",
        Title: "Line Comment",
      },
      lineCommentItems: this.parseFormColumns([
        {
          dataField: "Comment",
          gcLabel: " ",
          gcType: "String",
          editorType: "dxTextArea",
          editorOptions: {
            height: "140",
            maxLength: 500,
          },
        },
      ]),
      lineItemHistoryPopupVisible: false,
      lineItemHistoryModel: {
        dataGridAttributes: {
          id: "line-item-history-grid",
          class: "line-item-history-grid",
        },
        Title: "Line Item History",
        ItemHistoryDataSourceConfig: [],
      },
      transactionHistoryPopupVisible: false,
      invoicedListModel: {
        toolbar: {
          close: {
            icon: "showpanel",
            onClick: () => {
              this.showRightContainerInvoicedList = !this
                .showRightContainerInvoicedList;

              var grid = this.$refs["invoicedListGrid"].instance;
              grid.repaint();
            },
          },
          clear: {
            // icon: "clear",
            text: "Clear",
            onClick: () => {
              this.invoicedListModel.model.InvoiceNo = [];
              this.invoicedListModel.model.InvoiceDate = null;
              this.invoicedListModel.model.CustomerCode = [];
              this.invoicedListModel.model.DeliveryFirm = [];
              this.invoicedListModel.model.Status = [];
              this.invoicedListModel.model.OrderNo = [];
            },
          },
        },
        model: {
          InvoiceNo: [],
          InvoiceDate: null,
          OrderNo: [],
          CustomerCode: [],
          DeliveryFirm: [],
          Status: [],
        },
      },
      transactionHistoryModel: {
        Title: "Drawdown",
        TransactionHistoryDataSourceConfig: undefined,
        model: {
          CustomerSalesContractCode: null,
          LineNo: null,
          DateIn: null,
          RequiredByDate: null,
          ShipDate: null,
          OrderNo: [],
          CustomerDeliveryAddressLineNo: [],
          AgentRef: [],
          Confirmation: [],
          DeliveryFirm: [],
          ItemCode: [],
          FriendlyStatus: [],
        },
      },
      filterFormHeightDrawdown: undefined,
      noDataMessage: {
        addNew: {
          class: "add-new",
          title: "No Contract Lines",
          message: "Get Started, Add a Contract Line",
        },
      },
      enableNotesSave: false,
    };
  },
  created() {
    this.initialize();
  },
  updated() {
    validationEngine.validateGroup(this.formsConfig.validationGroup);
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
  },
  computed: {
    initialFilterDrawdown() {
      return [
        [
          "CustomerSalesContractCode",
          "=",
          this.transactionHistoryModel.model.CustomerSalesContractCode,
        ],
        "and",
        [
          "CustomerSalesContractLineNo",
          "=",
          this.transactionHistoryModel.model.LineNo,
        ],
      ];
    },

    getAdvanceFilterModelForDrawdown() {
      return this.transactionHistoryModel.model;
    },
    tabs() {
      return [
        {
          text: "Contract Details",
          path: `/sales-contract/${this.baseView.mode}/${this.baseView.id}/details`,
          applicationFeatureCode: "CustomerSalesContract",
        },
        {
          text: "Transactions",
          path: `/sales-contract/${this.baseView.mode}/${this.baseView.id}/transactions`,
          applicationFeatureCode: "CustomerSalesContract",
        },
      ];
    },
    transactionHistoryColumns() {
      return this.parseGridColumns("transaction", [
        {
          gcLabel: "SO #",
          dataField: "SalesOrderCode",
          width: 120,
          gcSubType: "TransactionNo",
          gcType: "String",
        },

        {
          gcLabel: "Date In",
          dataField: "DateIn",
          gcType: "Date",
        },
        {
          gcLabel: "Required By",
          dataField: "RequiredByDate",
          gcType: "Date",
        },
        {
          gcLabel: "Ship Date",
          dataField: "ShipDate",
          gcType: "Date",
        },
        {
          gcLabel: "PO",
          dataField: "OrderNo",
          width: 120,
          gcType: "String",
        },

        {
          gcLabel: "Agent Ref",
          dataField: "AgentRef",
          width: 120,
          gcType: "String",
        },
        {
          gcLabel: "Confirmation",
          dataField: "Confirmation",
          width: 120,
          gcType: "String",
        },
        {
          gcLabel: "Customer",
          dataField: "CustomerName",
          cellTemplate: "customer-cell-template", // GCS-RelatedRecordCellTemplate
          gcType: "String",
          gcSubType: "RelatedRecord",
          minWidth: this.gridColumnMinWidth(220), // GCS-RelatedRecordWidth
          gcExport: ["CustomerCode", "CustomerName"], // GCS-RelatedRecordCodeDescriptionExport
        },
        {
          gcLabel: "Delivery Firm",
          dataField: "CustomerDeliveryFirm",
          minWidth: this.gridColumnMinWidth(220),
          gcType: "String",
        },

        {
          gcLabel: "Product",
          dataField: "ItemDescription",
          allowHiding: false,
          cellTemplate: "product-cell-template", // GCS-RelatedRecordCellTemplate
          gcType: "String",
          gcSubType: "RelatedRecord",
          minWidth: this.gridColumnMinWidth(260),
          gcExport: ["ItemCode", "ItemDescription"], // GCS-RelatedRecordCodeDescriptionExport
        },
        {
          gcLabel: "UM",
          dataField: "SalesUM",
          // alignment: "left",
          width: 100,
          gcType: "String",
        },
        {
          gcLabel: "Drawn Ordered",
          dataField: "OrderedQuantity",
          gcType: "Decimal-4-2",
        },
        {
          gcLabel: "Drawn Invoiced",
          dataField: "InvoicedQuantity",
          gcType: "Decimal-4-2",
        },
        {
          gcType: "String",
          gcSubType: "Chip",
          cellTemplate: "status-cell-template",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Product Code",
          dataField: "ItemCode",
          gcSubType: "HiddenCode", // GCS-RelatedRecordCodeHidden
          gcType: "String",
          width: 100,
        },
        {
          gcLabel: "Product Name",
          dataField: "ItemDescription",
          gcSubType: "HiddenDescription", // GCS-RelatedRecordDescriptionHidden
          gcType: "String",
          minWidth: this.gridColumnMinWidth(220),
        },
      ]);
    },
    salesContractsInvoicedOrdersListColumns() {
      return this.parseGridColumns("transaction", [
        {
          gcLabel: "Invoice",
          dataField: "InvoiceNo",
          gcType: "Decimal-TransactionNo",
          gcSubType: "PrimaryTransactionNo",
        },
        {
          gcLabel: "Invoice Date",
          dataField: "DateIn",
          gcType: "Date",
          sortOrder: "desc",
        },

        {
          gcLabel: "Customer",
          dataField: "CustomerName",
          cellTemplate: "customer-cell-template", // GCS-RelatedRecordCellTemplate
          gcType: "String",
          gcSubType: "RelatedRecord",
          minWidth: this.gridColumnMinWidth(220), // GCS-RelatedRecordWidth
          gcExport: ["CustomerCode", "CustomerName"], // GCS-RelatedRecordCodeDescriptionExport
        },

        {
          gcLabel: "Customer Code",
          dataField: "CustomerCode",
          gcSubType: "HiddenCode", // GCS-RelatedRecordCodeHidden
          gcType: "String",
          width: 100,
        },
        {
          gcLabel: "Customer Name",
          dataField: "CustomerName",
          gcSubType: "HiddenDescription", // GCS-RelatedRecordDescriptionHidden
          gcType: "String",
          minWidth: this.gridColumnMinWidth(220),
        },
        {
          gcLabel: "Delivery Firm",
          dataField: "DeliveryFirm",
          gcType: "String",
          width: 240,
        },
        {
          gcLabel: "Sales Order",
          dataField: "SalesOrderCode",
          gcType: "Decimal-TransactionNo",
        },
        {
          gcLabel: "Customer PO",
          dataField: "OrderNo",
          gcType: "String",
          width: 100,
        },
        {
          gcLabel: "Due Date",
          dataField: "DueDate",
          gcType: "Date",
        },
        {
          gcLabel: "Inv Total",
          dataField: "InvoiceTotal",
          gcType: "Decimal-4-2C",
        },
        {
          gcLabel: "Balance",
          dataField: "Balance",
          gcType: "Decimal-4-2C",
        },
        {
          dataField: "FriendlyStatus",
          gcType: "String",
          gcSubType: "Chip",
          cellTemplate: "status-cell-template",
          showInColumnChooser: false,
        },
        {
          gcType: "String",
          gcSubType: "IconButton",
          cellTemplate: "menu-cell-template",
          cssClass: "more-menu",
          allowFixing: true,
          fixedPosition: "right",
          fixed: true,
          showInColumnChooser: false,
        },
      ]);
    },

    lineItemHistoryColumns() {
      return this.parseGridColumns("transaction", [
        {
          gcLabel: "Date",
          dataField: "DateCreated",
          // cellTemplate: "date-created-cell-template",

          gcType: "Date",
          gcSubType: "PrimaryDate",
          sortOrder: "desc",
        },
        {
          gcLabel: "User",
          dataField: "CreatedBy",
          gcType: "String",
          width: 100,
        },
        {
          gcLabel: "Product",
          dataField: "ItemCode",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(260),
        },

        {
          gcLabel: "Qty Change",
          dataField: "Quantity",
          gcType: "Decimal-4-2",
          // width: 150,
        },
        {
          gcLabel: "New Qty",
          dataField: "NewQuantity",
          gcType: "Decimal-4-2",
          // width: 150,
        },
        {
          gcLabel: "UM",
          dataField: "NewSalesUM",
          gcType: "String",
          // alignment: "left",
          width: 100,
        },
        {
          gcLabel: "Price",
          dataField: "DefaultPrice",
          // alignment: "right",
          gcType: "Decimal-4-4C",
          // width: 150,
        },
        {
          gcLabel: "New Price",
          dataField: "NewDefaultPrice",
          // alignment: "right",
          gcType: "Decimal-4-4C",
          // width: 150,
        },
        {
          gcLabel: "Comment",
          dataField: "Comment",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(100),
          // alignment: "left",
        },
      ]);
    },
    isEditVisible() {
      return this.model.Status !== "C" && this.model.Status !== "X";
    },
    isEditingAllowed() {
      return this.baseView.mode !== "review";
    },
    statusFreindly() {
      let status =
        this.model.Status == "" ? "A" : this.model.Status.toUpperCase();

      return status;
    },
    headerFormItems() {
      let items = [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: [
            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "Name",
                  gcLabel: "Name",
                  gcType: "String",
                  editorType: "dxTextBox",
                  editorOptions: {
                    readOnly: false,
                    maxLength: 200,
                  },
                  required: true,
                },
                {
                  dataField: "CustomerCode",
                  gcLabel: "Customer",
                  gcType: "String",
                  ref: "customerCode",
                  cssClass: "toolbar-customer-label",
                  editorType: this.isTablet ? "dxTextBox" : "dxSelectBox",
                  visible: this.model.Type != "Allocation",
                  validationRules:
                    this.model.Type != "Allocation"
                      ? [
                          {
                            type: "required",
                            message: "Customer is required",
                          },
                        ]
                      : [],
                  editorOptions: {
                    dataSource: customerDataSource,
                    valueExpr: "Code",
                    displayExpr: "Name",
                    searchExpr: ["Code", "Name"],
                    searchMode: "contains",
                    showClearButton: true,
                    itemTemplate: "agentTemplate",
                    searchEnabled: true,
                    onValueChanged: this.onCustomerCodeValueChanged.bind(this),
                    // key: "RecordId",
                    placeholder: "Customer Name",
                  },
                },
              ]),
            },

            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "Description",
                  gcLabel: "Description",
                  gcType: "String",
                  editorType: "dxTextArea",
                  editorOptions: {
                    readOnly: false,
                    maxLength: 1000,
                    height: 140,
                  },
                  required: true,
                },
              ]),
            },

            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "StartDate",
                  gcLabel: "Start Date",
                  gcType: "Date",
                  required: true,
                },
                {
                  dataField: "EndDate",
                  gcLabel: "End Date",
                  gcType: "Date",
                },
                {
                  dataField: "Status",
                  gcLabel: "Status",
                  gcType: "String",
                  editorType: "dxSelectBox",
                  required: true,
                  editorOptions: {
                    readOnly: this.baseView.mode == "create",
                    items: [
                      { id: "A", text: "Active" },
                      { id: "C", text: "Complete" },
                    ],
                    valueExpr: "id",
                    displayExpr: "text",
                  },
                },
              ]),
            },
          ],
        },
      ];

      return items;
    },
    toolbarFormItems() {
      return this.parseFormColumns([
        {
          dataField: "Type",
          gcLabel: "Type",
          gcType: "String",
          editorType: "dxSelectBox",
          editorOptions: {
            items: [
              { id: "Allocation", text: "Allocation" },
              { id: "Contract", text: "Contract" },
            ],
            valueExpr: "id",
            displayExpr: "text",
          },
          validationRules: [
            {
              type: "required",
              message: "Type is required",
            },
          ],
        },
      ]);
    },
    salesContractDetailsColumns() {
      return this.parseGridColumns("transaction", [
        {
          gcLabel: "Line",
          dataField: "LineNo",
          gcType: "Decimal-TransactionNo",
          gcSubType: "PrimaryTransactionNo",
          sortOrder: "asc",
        },
        {
          gcLabel: "Description",
          displayExpr: "Description",
          dataField: this.isEditingAllowed
            ? "CustomerSalesContractLineDescriptionRecordID"
            : "Description",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(200),
          allowEditing: this.isEditingAllowed,
          editCellTemplate: "contractDescriptionEditTemplate",
          visible: true,
          cssClass: this.cellEditorClass,
          showEditorAlways: this.isEditingAllowed,
        },
        {
          gcLabel: "UM",
          dataField: "SalesUM",
          gcType: "String",
          width: 150,
          cellTemplate: "sales-um-template",
          editCellTemplate: "salesUMEditTemplate",
          // showEditorAlways: true,
          cssClass: this.cellEditorClass,
          allowEditing: this.isEditingAllowed,
        },
        {
          gcLabel: "Quantity",
          dataField: "Quantity",
          // gcType: "String",
          editorType: "dxNumberBox",
          // alignment: "right",
          // width: 150,
          gcType: "Decimal-6-2",
          cssClass: this.cellEditorClass,
          editCellTemplate: "qtyEditTemplate",
          showEditorAlways: true,
        },
        {
          gcLabel: "Use Market $",
          dataField: "UseMarket",
          gcType: "String",
          editCellTemplate: "use-market-price-template",
          showEditorAlways: true,
          width: 100,
        },
        {
          gcLabel: "Apply Freight",
          dataField: "ApplyFreight",
          gcType: "String",
          editCellTemplate: "apply-freight-template",
          showEditorAlways: true,
          width: 100,
        },
        {
          gcDynamicLabel: this.salesContractColumnDefaultPriceLabel,
          dataField: "DefaultPrice",
          // gcType: "String",
          editorType: "dxNumberBox",
          alignment: "right",
          // width: 150,
          gcType: "Decimal-6-2",
          cssClass: this.cellEditorClass,
          editCellTemplate: "priceEditTemplate",
          showEditorAlways: true,
        },
        {
          gcLabel: "Drawn",
          dataField: "DrawnQuantity",
          // gcType: "String",
          gcType: "Decimal-6-2",
          //  width: 100,
          allowEditing: false,
        },
        {
          gcLabel: "",
          dataField: "",
          gcType: "String",
          width: 40,
          minWidth: this.gridColumnMinWidth(30),
          maxWidth: 80,
          cellTemplate: "menu-cell-template",
          //  alignment: "left",
          cssClass: "more-menu",
          fixedPosition: "right",
          fixed: true,
          allowFixing: true,
        },
      ]);
    },
    salesContractColumnDefaultPriceLabel() {
      return `Default Price (${this.model.CurrencyCode})`;
    },
    cellEditorClass() {
      return this.baseView.mode !== "review" ? "gc-editor-cell" : "";
    },
    cellEditorClassForDescription() {
      return this.baseView.mode !== "review"
        ? "gc-editor-cell-default-editor"
        : "gc-default-editor";
    },
    transactionHistoryFilterFormItems() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "DateIn",
              label: { text: "Date In" },
              editorType: "dxDateBox",
              editorOptions: {
                displayFormat: "dd MMM yyyy",
                showClearButton: true,
              },
            },
            {
              dataField: "RequiredByDate",
              label: { text: "Reqd Date" },
              editorType: "dxDateBox",
              editorOptions: {
                displayFormat: "dd MMM yyyy",
                showClearButton: true,
              },
            },
            {
              dataField: "ShipDate",
              label: { text: "Ship Date" },
              editorType: "dxDateBox",
              editorOptions: {
                displayFormat: "dd MMM yyyy",
                showClearButton: true,
              },
            },
            {
              dataField: "OrderNo",
              label: { text: "PO" },
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: CustomerSalesContractService.dataSourceConfig(
                  "api/CustomerSalesContractSalesOrderItemConsumption",
                  {
                    select: ["OrderNo"],
                    sort: [{ selector: "OrderNo", asc: true }],
                    top: 5,
                    filter: [
                      [
                        "CustomerSalesContractCode",
                        "=",
                        this.transactionHistoryModel.model
                          .CustomerSalesContractCode,
                      ],
                      [
                        "CustomerSalesContractLineNo",
                        "=",
                        this.transactionHistoryModel.model.LineNo,
                      ],
                    ],
                  }
                ),
                valueExpr: "OrderNo",
                displayExpr: "OrderNo",
                searchExpr: ["OrderNo"],
                searchMode: "contains",
                openOnFieldClick: true,
                searchEnabled: true,
              },
            },
            {
              dataField: "AgentRef",
              label: { text: "Agent Ref" },
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: CustomerSalesContractService.dataSourceConfig(
                  "api/CustomerSalesContractSalesOrderItemConsumption",
                  {
                    select: ["AgentRef"],
                    sort: [{ selector: "AgentRef", asc: true }],
                    top: 5,
                    filter: [
                      [
                        "CustomerSalesContractCode",
                        "=",
                        this.transactionHistoryModel.model
                          .CustomerSalesContractCode,
                      ],
                      [
                        "CustomerSalesContractLineNo",
                        "=",
                        this.transactionHistoryModel.model.LineNo,
                      ],
                    ],
                  }
                ),
                valueExpr: "AgentRef",
                displayExpr: "AgentRef",
                searchExpr: ["AgentRef"],
                searchMode: "contains",
                openOnFieldClick: true,
                searchEnabled: true,
              },
            },
            {
              dataField: "Confirmation",
              label: { text: "Confirmation" },
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: CustomerSalesContractService.dataSourceConfig(
                  "api/CustomerSalesContractSalesOrderItemConsumption",
                  {
                    select: ["Confirmation"],
                    sort: [{ selector: "Confirmation", asc: true }],
                    top: 5,
                    filter: [
                      [
                        "CustomerSalesContractCode",
                        "=",
                        this.transactionHistoryModel.model
                          .CustomerSalesContractCode,
                      ],
                      [
                        "CustomerSalesContractLineNo",
                        "=",
                        this.transactionHistoryModel.model.LineNo,
                      ],
                    ],
                  }
                ),
                valueExpr: "Confirmation",
                displayExpr: "Confirmation",
                searchExpr: ["Confirmation"],
                searchMode: "contains",
                openOnFieldClick: true,
                searchEnabled: true,
              },
            },
            {
              dataField: "CustomerCode",
              label: { text: "Customer" },
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: CustomerSalesContractService.dataSourceConfig(
                  "api/Customer",
                  {
                    select: [
                      "Code",
                      "Name",
                      "SalesRepresentativeCode",
                      "CurrencyCode",
                    ],
                    sort: [{ selector: "Name", asc: true }],
                    top: 5,
                    filter: ["Inactive", "=", "N"],
                    key: "Code",
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Name",
                searchExpr: ["Code", "Name"],
                searchMode: "contains",
                itemTemplate: "supplier-item-template",
                searchEnabled: true,
              },
            },
            {
              dataField: "CustomerDeliveryAddressLineNo",
              label: { text: "Delivery Firm" },
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: CustomerSalesContractService.dataSourceConfig(
                  "api/CustomerDeliveryAddressList",
                  {
                    select: [
                      "CompanyName",
                      "LineNo",
                      "LineNoAsString",
                      "PhysicalAddressStreetLine1",
                      "PhysicalAddressStreetLine2",
                      "PhysicalAddressSuburb",
                      "PhysicalAddressState",
                      "PhysicalAddressPostcode",
                      "PhysicalAddressCountry",
                      "RecordId",
                    ],
                    filter: ["CustomerCode", "=", this.model.CustomerCode],
                    key: "RecordId",
                  }
                ),
                valueExpr: "LineNoAsString",
                displayExpr: "CompanyName",
                searchExpr: ["CustomerCode", "CompanyName"],
                searchMode: "startswith",
                showClearButton: false,
                itemTemplate: "deliveryAddressTemplate",
                searchEnabled: true,
                openOnFieldClick: true,
              },
            },
            {
              dataField: "ItemCode",
              label: { text: "Product" },
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: ApiService.createDataSource(
                  "api/SaleItemCompanyBranch",
                  {
                    filter: [
                      ["CompanyCode", "=", this.model.CompanyCode],
                      ["BranchCode", "=", this.model.BranchCode],
                      ["ItemType", "=", "S"],
                      // ["SalesUM", "=", this.model.SalesUM],
                      ["Inactive", "=", "N"],
                      ["AvailableForSale", "=", "Y"],
                      ["Status", "=", "A"],
                    ],
                    select: [
                      "ItemCode",
                      "Description",
                      "Inactive",
                      "SalesUM",
                      "BranchCode",
                      "CompanyCode",
                    ],
                  }
                ),
                displayExpr: "Description",
                valueExpr: "ItemCode",
                searchExpr: ["ItemCode", "Description"],
                searchMode: "contains",
                itemTemplate: "product-cell-template",
                openOnFieldClick: true,
                searchEnabled: true,
              },
            },
            {
              dataField: "FriendlyStatus",
              label: { text: "Status" },
              editorType: "dxTagBox",
              editorOptions: {
                items: [
                  { text: "Active", value: "Active" },
                  { text: "Draft", value: "Draft" },
                  { text: "Completed", value: "Completed" },
                  { text: "Locked", value: "Locked" },
                  { text: "Pending", value: "Pending" },
                ],
                valueExpr: "value",
                displayExpr: "text",
                searchEnabled: true,
              },
            },
          ],
        },
      ];

      return formFields;
    },
    invoicedListFilterFormItems() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "InvoiceNo",
              label: { text: "Invoice" },
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: CustomerSalesContractService.dataSourceConfig(
                  "api/SalesContractsInvoicedOrdersList",
                  {
                    select: ["InvoiceNo"],
                    sort: [{ selector: "OrderNo", asc: true }],
                    top: 5,
                    filter: [
                      ["CustomerSalesContractCode", "=", this.model.Code],
                    ],
                  }
                ),
                valueExpr: "InvoiceNo",
                displayExpr: "InvoiceNo",
                searchExpr: ["InvoiceNo"],

                onValueChanged: this.applyCustomFilterInvoicedList.bind(this),
                openOnFieldClick: true,
                searchEnabled: true,
              },
            },
            {
              dataField: "InvoiceDate",
              label: { text: "Invoice Date" },
              editorType: "dxDateBox",
              editorOptions: {
                displayFormat: "dd MMM yyyy",
                onValueChanged: this.applyCustomFilterInvoicedList.bind(this),
                showClearButton: true,
              },
            },

            {
              dataField: "OrderNo",
              label: { text: "Customer PO" },
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: CustomerSalesContractService.dataSourceConfig(
                  "api/SalesContractsInvoicedOrdersList",
                  {
                    select: ["OrderNo"],
                    sort: [{ selector: "OrderNo", asc: true }],
                    top: 5,
                    filter: [
                      ["CustomerSalesContractCode", "=", this.model.Code],
                    ],
                  }
                ),
                valueExpr: "OrderNo",
                displayExpr: "OrderNo",
                searchExpr: ["OrderNo"],
                searchMode: "contains",
                onValueChanged: this.applyCustomFilterInvoicedList.bind(this),
                openOnFieldClick: true,
                searchEnabled: true,
              },
            },
            {
              dataField: "DeliveryFirm",
              label: { text: "Delivery Firm" },
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: CustomerSalesContractService.dataSourceConfig(
                  "api/CustomerDeliveryAddress",
                  {
                    select: [
                      "CompanyName",
                      "LineNo",
                      "PhysicalAddressStreetLine1",
                      "PhysicalAddressStreetLine2",
                      "PhysicalAddressSuburb",
                      "PhysicalAddressState",
                      "PhysicalAddressPostcode",
                      "PhysicalAddressCountry",
                      "RecordId",
                    ],
                    filter: ["CustomerCode", "=", this.model.CustomerCode],
                    key: "RecordId",
                  }
                ),
                valueExpr: "CompanyName",
                displayExpr: "CompanyName",
                searchExpr: ["CustomerCode", "CompanyName"],
                searchMode: "contains",
                showClearButton: false,
                itemTemplate: "deliveryAddressTemplate",
                searchEnabled: true,
                openOnFieldClick: true,
                onValueChanged: this.applyCustomFilterInvoicedList.bind(this),
              },
            },
            {
              dataField: "CustomerCode",
              label: { text: "Customer" },
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: CustomerSalesContractService.dataSourceConfig(
                  "api/Customer",
                  {
                    select: [
                      "Code",
                      "Name",
                      "SalesRepresentativeCode",
                      "CurrencyCode",
                    ],
                    sort: [{ selector: "Name", asc: true }],
                    top: 5,
                    filter: ["Inactive", "=", "N"],
                    key: "Code",
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Code",
                searchExpr: ["Code", "Name"],
                searchMode: "contains",
                itemTemplate: "filterCustomerTemplate",
                onValueChanged: this.applyCustomFilterInvoicedList.bind(this),
                openOnFieldClick: true,
                searchEnabled: true,
              },
            },
            {
              dataField: "Status",
              label: { text: "Status" },
              editorType: "dxTagBox",
              editorOptions: {
                items: [
                  { text: "Open", value: "Open" },
                  { text: "Paid", value: "Paid" },
                ],
                valueExpr: "value",
                displayExpr: "text",
                onValueChanged: this.applyCustomFilterInvoicedList.bind(this),
                searchEnabled: true,
              },
            },
          ],
        },
      ];

      return formFields;
    },
  },
  methods: {
    onNotesCellKeyDown() {
      this.notePopupSaveButtonDisabled = false;
    },
    onRowDelete() {
      this.enableNotesSave = true;
      this.notePopupSaveButtonDisabled = false;
    },
    async onPopupLineCommentSaveButtonClick() {
      this.showLoading(true);
      var noteList = [];
      var CustomerSalesContractNoteList = [...this.orderNotesDataSourceConfig];
      CustomerSalesContractNoteList.forEach((CustomerSalesContractNote) => {
        if (CustomerSalesContractNote.Note) {
          var note;
          if (CustomerSalesContractNote.RecordId === undefined) {
            note = {
              CustomerSalesContractCode: this.salesContractCode,
              DateCreated: new Date(),
              Note: CustomerSalesContractNote.Note,
              RecordId: "",
            };
          } else {
            note = {
              CustomerSalesContractCode: this.salesContractCode,
              DateChanged: CustomerSalesContractNote.DateChanged, // new Date(),
              Note: CustomerSalesContractNote.Note,
              RecordId: CustomerSalesContractNote.RecordId,
            };
          }

          noteList.push(note);
        }
      });

      var Payload = {
        Codes: "123",
        CustomerSalesContractNotes: noteList,
      };

      await CustomerSalesContractService.saveAll(Payload)
        .then(async (res) => {
          let { data } = await CustomerSalesContractService.getByCode(
            this.model.Code
          );
          if (data && res) {
            this.salesContractCode = data.value[0].Code;
            this.salesContractObj = data.value[0];
            this.populateHeader(data.value[0], this.model);
          }

          let record = await CustomerSalesContractService.getByCode(
            this.model.Code
          );
          this.orderNotesDataSourceConfig =
            record.data.value[0].CustomerSalesContractNoteList;

          this.showLoading(false);
          this.notesPopupVisible = false;
        })
        .catch((err) => {
          if (err) this.showLoading(false);
          this.displayServerError(err, "Save Order Notes Failed");
        });
      // });
    },
    onPopupLineCommentCancelButtonClick() {
      this.notesPopupVisible = false;
    },
    onNoteKeyUp() {
      this.enableNotesSave = false;
    },
    onValueChangedNoteKeyUp(e, data) {
      data.data.Note = e.value;
      data.data.DateChanged = new Date();
      this.enableNotesSave = true;
    },
    onNotesPopupHidden() {
      this.enableNotesSave = false;
      const maxLineNo = Math.max.apply(
        Math,
        this.orderNotesDataSourceConfig.map(function(o) {
          return o.LineNo ? o.LineNo : -1;
        })
      );
      let notes = this.orderNotesDataSourceConfig.map((note) => {
        let n = {
          LineNo: maxLineNo + 1,
          Note: note.Note,
        };
        return n;
      });
      this.model.SalesOrderNotes = notes;
    },
    onAddClickHandler() {
      this.orderNotesDataSourceConfig.unshift({
        ChangedBy: undefined,
        CreatedBy: undefined,
        CustomerSalesContractCode: undefined,
        DateChanged: undefined,
        DateCreated: undefined,
        Note: undefined,
        // RecordId: "00000000-0000-0000-0000-000000000000",
      });
    },
    setMaxLength(e) {
      if (e.parentType == "dataRow" && e.dataField == "Note") {
        e.editorOptions.maxLength = 1000;
      }
    },
    onRowClick(e) {
      if (this.baseView.mode != "review") {
        let grid = this.$refs[this.gridRefName].instance;
        grid.editRow(e.rowIndex);
      }
    },
    notesToolbarPreparing(e) {
      // if (this.baseView.mode != "review") {

      e.toolbarOptions.items.unshift(
        // This is an example of a toolbar button(e.g This code depicts the Grid Refresh button). We may substitute relevant properties to cater for any Toolbar button.
        {
          location: "left",
          widget: "dxButton",

          options: {
            icon: "plus",
            visible: FeatureStorage.checkPermission(
              "CustomerSalesContract",
              "create"
            ),
            // color:"white",
            text: "Add Note",
            onClick: this.onAddClickHandler.bind(this),
          },
        }
      );
      // }
    },
    moreMenuCallBack(itemData, parentData) {
      if (itemData.menuText == "Drawdown") {
        let rowData = itemData.data.data;
        this.transactionHistoryModel.Title = `Line ${parentData.LineNo} ${rowData.ProductDescription} Drawdown`;
        this.transactionHistoryModel.model.CustomerSalesContractCode =
          rowData.CustomerSalesContractCode;
        this.transactionHistoryModel.model.LineNo = parentData.LineNo;
        this.transactionHistoryModel.TransactionHistoryDataSourceConfig = this.getTransactionHistoryDataSource(
          rowData.CustomerSalesContractCode,
          parentData.LineNo,
          itemData.data.data.ProductCode
        );
        this.transactionHistoryPopupVisible = true;
        this.$logger.trackEventOpenPopup("Sales Contract Drawdown History");
      } else if (itemData.menuText == "View History") {
        let rowData = itemData.data.data;
        this.lineItemHistoryModel.Title = `Contract #${parentData.LineNo} ${rowData.ProductDescription} History`;
        this.lineItemHistoryModel.ItemHistoryDataSourceConfig = this.getLineItemHistoryDataSource(
          rowData.CustomerSalesContractCode,
          parentData.LineNo,
          itemData.data.data.ProductCode
        );
        this.lineItemHistoryPopupVisible = true;
        this.$logger.trackEventOpenPopup("Sales Contract Item History");
      } else if (itemData.menuText == "Generate Order") {
        // Item Code level Generate Order
        var data = { ...parentData };
        data.CustomerSalesContractItemConsumptions = [itemData.data.data];
        this.selectedContractLine = data;
        this.generateSalesOrderFromContractLinePopupVisible = true;
      }
    },
    listContentReady() {
      // eslint-disable-next-line no-console
      if (document.getElementById("transaction-history-grid")) {
        this.filterFormHeightDrawdown =
          document
            .getElementById("transaction-history-grid")
            .getElementsByClassName("dx-datagrid dx-gridbase-container")[0]
            .clientHeight -
          document
            .getElementById("transaction-history-grid")
            .getElementsByClassName("dx-datagrid-header-panel")[0]
            .clientHeight -
          30;
      }
    },

    async applyCustomFilterInvoicedList() {
      const createFilter = [];

      createFilter.push([["CustomerSalesContractCode", "=", this.model.Code]]);

      if (this.invoicedListModel.model.Status.length != 0) {
        let afilter = [];
        for (
          let index = 0;
          index < this.invoicedListModel.model.Status.length;
          index++
        ) {
          if (this.invoicedListModel.model.Status[index] == "Open") {
            let filter = ["DateSettled", "=", null];
            afilter.push(filter);
          } else {
            let filter = ["DateSettled", "<>", null];
            afilter.push(filter);
          }
          if (index != this.invoicedListModel.model.Status.length - 1) {
            afilter.push("or");
          }
        }
        createFilter.push(afilter);
      }

      if (this.invoicedListModel.model.OrderNo.length != 0) {
        let afilter = [];
        for (
          let index = 0;
          index < this.invoicedListModel.model.OrderNo.length;
          index++
        ) {
          let filter = [
            "OrderNo",
            "=",
            this.invoicedListModel.model.OrderNo[index],
          ];
          afilter.push(filter);
          if (index != this.invoicedListModel.model.OrderNo.length - 1) {
            afilter.push("or");
          }
        }

        if (createFilter.length > 0) {
          createFilter.push("and");
          createFilter.push(afilter);
        } else {
          createFilter.push(afilter);
        }
      }

      if (this.invoicedListModel.model.InvoiceNo.length != 0) {
        let afilter = [];
        for (
          let index = 0;
          index < this.invoicedListModel.model.InvoiceNo.length;
          index++
        ) {
          let filter = [
            "InvoiceNo",
            "=",
            this.invoicedListModel.model.InvoiceNo[index],
          ];
          afilter.push(filter);
          if (index != this.invoicedListModel.model.InvoiceNo.length - 1) {
            afilter.push("or");
          }
        }

        if (createFilter.length > 0) {
          createFilter.push("and");
          createFilter.push(afilter);
        } else {
          createFilter.push(afilter);
        }
      }

      if (this.invoicedListModel.model.DeliveryFirm.length != 0) {
        let afilter = [];
        for (
          let index = 0;
          index < this.invoicedListModel.model.DeliveryFirm.length;
          index++
        ) {
          let filter = [
            "DeliveryFirm",
            "=",
            `${this.invoicedListModel.model.DeliveryFirm[index]}`,
          ];
          afilter.push(filter);
          if (index != this.invoicedListModel.model.DeliveryFirm.length - 1) {
            afilter.push("or");
          }
        }

        if (createFilter.length > 0) {
          createFilter.push("and");
          createFilter.push(afilter);
        } else {
          createFilter.push(afilter);
        }
      }

      if (this.invoicedListModel.model.CustomerCode.length != 0) {
        let afilter = [];
        for (
          let index = 0;
          index < this.invoicedListModel.model.CustomerCode.length;
          index++
        ) {
          let filter = [
            "CustomerCode",
            "=",
            this.invoicedListModel.model.CustomerCode[index],
          ];
          afilter.push(filter);
          if (index != this.invoicedListModel.model.CustomerCode.length - 1) {
            afilter.push("or");
          }
        }

        if (createFilter.length > 0) {
          createFilter.push("and");
          createFilter.push(afilter);
        } else {
          createFilter.push(afilter);
        }
      }

      // /ItemCode

      if (this.invoicedListModel.model.InvoiceDate != null) {
        let date = this.invoicedListModel.model.InvoiceDate.toYYYYMMDD().split(
          "-"
        );
        let afilter = [
          ["year(DateIn)", "=", parseInt(date[0])],
          "and",
          ["month(DateIn)", "=", parseInt(date[1])],
          "and",
          ["day(DateIn)", "=", parseInt(date[2])],
        ];

        if (createFilter.length > 0) {
          createFilter.push("and");
          createFilter.push(afilter);
        } else {
          createFilter.push(afilter);
        }
      }

      if (createFilter.length == 0) {
        var grid = this.$refs["transactionHistoryGrid"].instance;
        grid.clearFilter();
      } else {
        salesContractsInvoicedOrdersListDs.filter(createFilter);
      }

      this.salesContractsInvoicedOrdersList.load();
    },
    onToolbarPreparingInvoicedList(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });

      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });
      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" &&
          item.name !== "exportButton" &&
          item.name !== "columnChooserButton"
        );
      });

      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            onClick: () => {
              this.showRightContainerInvoicedList = !this
                .showRightContainerInvoicedList;
              var grid = this.$refs["invoicedListGrid"].instance;
              grid.repaint();
            },
            visible: !this.showRightContainerInvoicedList,
          },
        }
      );
    },
    onToolbarPreparingDrawdownHistory(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" &&
          item.name !== "exportButton" &&
          item.name !== "columnChooserButton"
        );
      });
      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var grid = this.$refs["transactionHistoryGrid"].instance;
              grid.repaint();
            },
            visible: !this.showFilterRightContainer,
          },
        }
      );
    },
    onPrintClick() {
      // eslint-disable-next-line no-console

      this.displayValidationSummary([]);
      this.addErrorMessage(`Report not found`);
      this.displayValidationSummary();
    },
    async handleLocalRouteChange() {
      setTimeout(() => {
        this.setTabSelection();
      }, 100);
    },
    setTabSelection() {
      if (this.baseView.tab === "transactions") {
        this.selectedIndex = 1;
        this.salesContractsInvoicedOrdersList.load(); // fixup the quirky grid presentation
      } else {
        this.selectedIndex = 0;
        this.loadingCompleted = true;
      }
    },

    async initialize() {
      this.showLoading(true);
      this.loadingCompleted = false;
      this.salesUMDs = await unitOfMeasureDs.load();
      CustomerSalesContractDescription.getAllDescriptionsAndRecordIds()
        .then((response) => {
          this.contractDescriptions = response.data.value;
        })
        .catch((error) => {
          this.$logger.debug(
            "Unable to fetch Customer Sales Contract Description data",
            error
          );
        });
      orderNotesDataSource.filter(["SalesOrderCode", "=", this.model.Code]);
      orderNotesDataSource.load().then(() => {
        this.orderNotesDataSourceConfig = orderNotesDataSource.items();
      });
      await this.getDefaults().then(async (response) => {
        if (response.data.value.length > 0) {
          this.model.CompanyCode = response.data.value[0].CompanyCode;
          this.model.BranchCode = response.data.value[0].BranchCode;
          this.model.DivisionCode = response.data.value[0].DivisionCode;

          await CompanyService.getByCompanyCode(this.model.CompanyCode).then(
            (res) => {
              this.model.CurrencyCode = res.data.value[0].CurrencyCode;
            }
          );
          this.loadingCompleted = true;
          this.showLoading(false);
        }
      });

      if (this.baseView.mode !== "create") {
        this.showLoading(true);
        this.loadingCompleted = false;
        this.model.Code = this.baseView.id;

        let record = await CustomerSalesContractService.getByCode(
          this.model.Code
        );
        if (record) {
          this.salesContractCode = record.data.value[0].Code;
          this.salesContractObj = record.data.value[0];
          this.populateHeader(record.data.value[0], this.model);
        }

        if (this.model.CustomerCode !== null) {
          let customer = await CustomerService.getByCode(
            this.model.CustomerCode
          );
          this.model.CurrencyCode = customer.data.value[0].CurrencyCode;
        }

        customerSalesContractLineDataSource.filter([
          "CustomerSalesContractCode",
          "=",
          this.model.Code,
        ]);
        this.customerSalesContractLineDataSourceConfig = await customerSalesContractLineDataSource.load();

        if (this.baseView.mode == "review") {
          this.toolbar.headerActions.items[0].disabled =
            this.model.Status == "C";
          let toolbarn = this.$refs["toolbar-header"].instance;
          toolbarn.repaint();
        }

        if (this.model.Type == "Allocation") {
          this.toolbar.headerActions.items.splice(1, 1);
          let toolbarn = this.$refs["toolbar-header"].instance;
          toolbarn.repaint();
        }

        this.loadingCompleted = true;
        this.showLoading(false);

        this.salesContractsInvoicedOrdersList.filter([
          "CustomerSalesContractCode",
          "=",
          this.model.Code,
        ]);
        this.salesContractsInvoicedOrdersList.load();
      }
    },
    async onContractLineContextMenuItemClick(e) {
      if (e.itemData.menuText == "Edit Comment") {
        let rowData = e.itemData.data.data;

        currentContractLineKey = e.itemData.data.key;

        // eslint-disable-next-line no-console
        this.$logger.debug("rowData", rowData, currentContractLineKey);

        this.lineCommentModel.Comment = rowData.Comment;
        this.lineCommentModel.Title = `${rowData.LineNo} ${rowData.Description} Comment`;

        this.lineCommentsPopupVisible = true;
        this.$logger.trackEventOpenPopup("Sales Contract Line Comment");
        // let form = this.$refs["line-comments-form"].instance;
        // form.repaint();
      } else if (e.itemData.menuText == "Delete Line") {
        let rowData = e.itemData.data.data;

        let message = rowData.Description
          ? `Are you sure you want to delete line "${rowData.Description}"?`
          : `Are you sure you want to delete this line?`;
        let confirmLineDeletion = await this.$confirm(
          message,
          `Delete ${rowData.Description}`
        );

        if (confirmLineDeletion) {
          let rowIndex = this.customerSalesContractLineDataSourceConfig.findIndex(
            (x) => x.Key == e.itemData.data.key
          );

          this.customerSalesContractLineDataSourceConfig.splice(rowIndex, 1);
        }
      } else if (e.itemData.menuText == "View History") {
        let rowData = e.itemData.data.data;
        this.lineItemHistoryModel.Title = `Contract #${rowData.LineNo} ${rowData.Description} History`;
        this.lineItemHistoryModel.ItemHistoryDataSourceConfig = this.getLineItemHistoryDataSource(
          rowData.CustomerSalesContractCode,
          rowData.LineNo
        );
        this.lineItemHistoryPopupVisible = true;
        this.$logger.trackEventOpenPopup("Sales Contract Item History");
      } else if (e.itemData.menuText == "Drawdown") {
        let rowData = e.itemData.data.data;
        this.transactionHistoryModel.Title = `Line ${rowData.LineNo} ${rowData.Description} Drawdown`;
        this.transactionHistoryModel.model.CustomerSalesContractCode =
          rowData.CustomerSalesContractCode;
        this.transactionHistoryModel.model.LineNo = rowData.LineNo;
        this.transactionHistoryModel.TransactionHistoryDataSourceConfig = this.getTransactionHistoryDataSource(
          rowData.CustomerSalesContractCode,
          rowData.LineNo
        );
        this.transactionHistoryPopupVisible = true;
        this.$logger.trackEventOpenPopup("Sales Contract Drawdown History");
        // Drawdown
      } else if (e.itemData.menuText == "Generate Order") {
        // Contract Line level Generate Order
        this.selectedContractLine = e.itemData.data.data;
        this.generateSalesOrderFromContractLinePopupVisible = true;
      }
    },
    popupLineCommentBackButtonClick() {
      let rowIndex = this.customerSalesContractLineDataSourceConfig.findIndex(
        (x) => x.Key == currentContractLineKey
      );
      this.customerSalesContractLineDataSourceConfig[
        rowIndex
      ].Comment = this.lineCommentModel.Comment;

      this.lineCommentsPopupVisible = false;
    },
    // eslint-disable-next-line no-unused-vars
    updateReviewList(data) {},
    useMarketValueChanged(e, data) {
      data.data.UseMarket = e.value ? "Y" : "N";
    },
    applyFreightValueChanged(e, data) {
      data.data.ApplyFreight = e.value ? "Y" : "N";
    },
    defaultPriceChanged(e, data) {
      data.data.DefaultPrice = e.value;
    },
    lineQtyChanged(e, data) {
      if (!e.event) return;
      data.data.Quantity = e.value;

      var lineQty = 0;
      data.data.CustomerSalesContractItemConsumptions.forEach((element) => {
        lineQty = lineQty + element.Quantity;
      });

      if (data.data.CustomerSalesContractItemConsumptions.length > 0) {
        if (e.value < lineQty) data.data.Quantity = lineQty;
      }

      e.component.beginUpdate();
      e.component.option("value", data.data.Quantity);
      e.component.endUpdate();
    },
    onCellPrepared(e) {
      if (e.rowType === "data" && e.column.command === "expand") {
        if (e.data.IsBatchProduct == "No") {
          e.cellElement.classList.remove("dx-datagrid-expand");
          e.cellElement.childNodes[0].classList.remove(
            "dx-datagrid-group-closed"
          );
        }
      }
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return item.name !== "searchPanel";
      });

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add Line",
            onClick: () => {
              // create a new dummy line by deep clone
              let lineObj = JSON.parse(JSON.stringify(baseLineRecord));
              lineObj["Key"] = contractLineNextKey++;
              lineObj.SalesUM = this.salesUMDs[0].Code;
              // add to line datasource
              this.customerSalesContractLineDataSourceConfig.push(lineObj);
            },
            visible: this.isEditingAllowed,
          },
        },
        searchPanel
      );
    },
    stockTransferDetailsInitialized(e) {
      stockTransferDetailsGridInstance = e.component;
      window.grid = stockTransferDetailsGridInstance;

      if (reviewModeSearchText !== "") {
        e.component.searchByText(reviewModeSearchText);
      }
    },
    async onCustomerCodeValueChanged(e) {
      this.$logger.debug("onCustomerCodeValueChanged", e);
      let itemData = null;
      if (
        e.component.option("items") &&
        e.component.option("items").length > 0
      ) {
        itemData = e.component.option("items").find((x) => x.Code == e.value);
        this.model.CurrencyCode = itemData.CurrencyCode;
      }

      this.$logger.debug("Selected Customer", itemData);
    },

    backButtonFunction() {
      this.$router.push({
        path: "/sales-contract",
      });
    },
    populateHeader(responseModel, targetModel) {
      targetModel.Code = responseModel.Code;
      targetModel.CustomerCode = responseModel.CustomerCode;
      targetModel.Description = responseModel.Description;
      targetModel.StartDate = responseModel.StartDate;
      targetModel.EndDate = responseModel.EndDate;
      targetModel.Name = responseModel.Name;
      targetModel.ParentCustomerSalesContractCode =
        responseModel.ParentCustomerSalesContractCode;
      targetModel.Status = responseModel.Status;
      targetModel.Type = responseModel.Type;
      this.orderNotesDataSourceConfig =
        responseModel.CustomerSalesContractNoteList;
    },
    onFormContentReady() {
      validationEngine.validateGroup("formsData");
      validationEngine.validateGroup("headerFormsData");
    },
    validateContractLines(contractLines) {
      let isCommentRequiredValid = true,
        isRequiredFieldsValid = true,
        isProductRequiredFieldsValid = true;
      validationErrors = [];
      let lineCommentErrors = [];
      let productErrors = [];
      contractLines.forEach((data) => {
        if (
          (data.Description &&
            data.SalesUM &&
            data.Quantity > 0 &&
            data.DefaultPrice >= 0) == false
        ) {
          isRequiredFieldsValid = false;
        }

        if (data.LineNo && data.LineNo > 0) {
          if (
            data.OldSalesUM !== data.SalesUM ||
            data.OldQuantity !== data.Quantity ||
            data.OldDefaultPrice !== data.DefaultPrice
          ) {
            if (!data.Comment) {
              lineCommentErrors.push(
                `Comment required for 'Line ${data.LineNo}'`
              );
              isCommentRequiredValid = false;
            }
          }
        }

        if (data.CustomerSalesContractItemConsumptions.length == 0) {
          validationErrors.push(
            `Each line on a contract must have at least one item with a contract quantity equal to the contract line quantity.`
          );
          isRequiredFieldsValid = false;
        }

        // finding duplicate products
        let productCodes = data.CustomerSalesContractItemConsumptions.map(
          (x) => x.ProductCode
        );

        let findDuplicates = (arr) =>
          arr.filter((item, index) => arr.indexOf(item) != index);
        let duplicateProducts = [...new Set(findDuplicates(productCodes))];

        if (duplicateProducts.length > 0) {
          duplicateProducts.forEach((productCode) => {
            productErrors.push(
              `Duplicate Product ${productCode} on line ${data.Description}`
            );
            isProductRequiredFieldsValid = false;
          });
        }

        data.CustomerSalesContractItemConsumptions.forEach((product, index) => {
          if ((product.ProductCode && product.DefaultPrice >= 0) == false) {
            productErrors.push(
              `${data.Description} , Product ${index +
                1} must have a product selected.`
            );
            isProductRequiredFieldsValid = false;
          }
        });
      });

      if (isRequiredFieldsValid == false) {
        validationErrors.push(
          "Each contract line must have a description and a quantity greater than 0. Please update the contract lines before attempting to save."
        );
        return false;
      }

      if (isCommentRequiredValid == false) {
        validationErrors = lineCommentErrors;
        return false;
      }

      if (isProductRequiredFieldsValid == false) {
        validationErrors = productErrors;
        return false;
      }

      return (
        isCommentRequiredValid &&
        isRequiredFieldsValid &&
        isProductRequiredFieldsValid
      );
    },
    async showGenerateSoValidationErrors(validationResult) {
      this.addErrorMessagesFromValidationResult(validationResult);
      this.displayValidationSummary();
    },
    showServerErrors(error, errorTitle) {
      this.displayServerError(error, errorTitle);
    },
    showLoadingHelper(state) {
      this.showLoading(state);
    },
    async saveSalesContract() {
      // eslint-disable-next-line no-console
      this.$logger.debug("saveSalesContract");

      let validationResult = await validationEngine.validateGroup(
        this.formsConfig.validationGroup
      );

      if (!validationResult.isValid) {
        this.addErrorMessagesFromValidationResult(validationResult);
        this.displayValidationSummary();
        return;
      }

      validationResult = await validationEngine.validateGroup(
        "headerFormsData"
      );
      if (!validationResult.isValid) {
        this.addErrorMessagesFromValidationResult(validationResult);
        this.displayValidationSummary();
        return;
      }

      let contractLinesValid = this.validateContractLines(
        this.customerSalesContractLineDataSourceConfig
      );

      if (!contractLinesValid) {
        this.displayValidationSummary(validationErrors);
        return;
      }

      let contractLineItemValid = this.validateContractLineItems(
        this.customerSalesContractLineDataSourceConfig
      );

      if (!contractLineItemValid && validationErrors.length > 0) {
        this.displayValidationSummary(validationErrors);
        return;
      }

      this.showLoading(true);
      await CustomerSalesContractListService.save(
        this.getSavePayload(),
        this.model.Code
      )
        .then((res) => {
          this.showLoading(false);

          if (this.baseView.mode == "create") {
            this.model.Code = res.data.Code;
          }
          this.$notify(
            `Sales Contract ${this.model.Code} Successfully Saved`,
            "success"
          );

          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/sales-contract/review/${this.model.Code}`,
          });
          this.initialize();
        })
        .catch((error) => {
          this.displayServerError(error, "Save sales contract Failed");
        });
    },
    validateContractLineItems(lineItems) {
      lineItems.forEach((element) => {
        var lineQty = 0;
        element.CustomerSalesContractItemConsumptions.forEach((line) => {
          lineQty = lineQty + line.Quantity;
        });

        if (
          lineQty.roundNumber(2) != element.Quantity.roundNumber(2) &&
          element.CustomerSalesContractItemConsumptions.length > 0
        ) {
          validationErrors = [];
          if (element.CustomerSalesContractItemConsumptions.length == 1) {
            validationErrors.push(
              "The  product code contract quantity entered does not match the contract line quantity."
            );
            return false;
          } else {
            validationErrors.push(
              "The sum of the product code contract quantities does not match the contract line quantity."
            );
            return false;
          }
        } else {
          return true;
        }
      });
    },
    getSavePayload() {
      let payload = {};
      this.populateHeader(this.model, payload);

      if (this.model.Type == "Allocation") {
        payload.CustomerCode = null;
      }

      payload.StartDate = new Date(payload.StartDate).toSaveDate();
      payload.EndDate = payload.EndDate
        ? new Date(payload.EndDate).toSaveDate()
        : null;

      payload.CustomerSalesContractLines = this.getCustomerSalesContractLinesPayload();

      if (this.baseView.mode == "create") delete payload.Code;
      return payload;
    },
    getCustomerSalesContractLinesPayload() {
      let details = [];
      this.customerSalesContractLineDataSourceConfig.forEach((data) => {
        let detailObj = {
          CustomerSalesContractCode: data.CustomerSalesContractCode,
          LineNo: data.LineNo,
          Description: data.Description,
          CustomerSalesContractLineDescriptionRecordID:
            data.CustomerSalesContractLineDescriptionRecordID,
          SalesUM: data.SalesUM,
          Quantity: data.Quantity,
          UseMarket: data.UseMarket,
          ApplyFreight: data.ApplyFreight,
          DefaultPrice: data.DefaultPrice,
          Comment: data.Comment,
          RecordId: data.RecordId,
        };

        detailObj.CustomerSalesContractItems = this.getLineProductDetailsPayload(
          data.CustomerSalesContractItemConsumptions
        );

        details.push(detailObj);
      });
      return details;
    },
    getLineProductDetailsPayload(items) {
      let itemsPayload = [];
      items.forEach((item) => {
        let itemObj = {
          ProductCode: item.ProductCode,
          DefaultPrice: item.DefaultPrice,
          LineNo: item.LineNo ? item.LineNo : 0,
          RecordId: item.RecordId,
          Quantity: item.Quantity,
        };

        itemsPayload.push(itemObj);
      });

      return itemsPayload;
    },
    async getDefaults() {
      return await DefaultCompanyBranchDivisionService.getDefault();
    },
    contractDescriptionCodeChanged(e, cellInfo) {
      cellInfo.data.CustomerSalesContractLineDescriptionRecordID =
        e.selectedItem.RecordId;
      cellInfo.data.Description = e.selectedItem.Description;
    },
    async salesUmValueChanged(args, cellInfo) {
      this.$logger.debug(args, "salesUmValueChanged args");

      if (cellInfo.data.CustomerSalesContractItemConsumptions.length > 0) {
        let message = `Line contains products that belong to the UM ${args.previousValue}. Do you wish to remove these items and change to the UM ${args.value}?`;

        let confirmSalesUmChange = await this.$confirm(message, `Confirmation`);
        if (confirmSalesUmChange) {
          cellInfo.data.SalesUM = args.value;
          cellInfo.data.CustomerSalesContractItemConsumptions = [];
          stockTransferDetailsGridInstance.refresh();
        } else {
          let salesUmEditor = args.component;

          salesUmEditor.option("onValueChanged", null);

          setTimeout(() => {
            salesUmEditor.option(
              "onValueChanged",
              this.salesUmValueChanged.bind(this)
            );
          }, 500);
        }
      } else {
        // eslint-disable-next-line no-console
        this.$logger.debug(cellInfo, "Cell Info");
        cellInfo.data.SalesUM = args.value;
        cellInfo.data.CustomerSalesContractItemConsumptions = [];
        stockTransferDetailsGridInstance.refresh();
      }
    },
    customizeLineCommentItem(item) {
      if (item.itemType == "simple") {
        item.editorOptions = item.editorOptions || {};
        if (item.dataField == "Comment") {
          item.editorOptions.readOnly = this.baseView.mode == "review";
        } else {
          item.editorOptions.disabled = this.baseView.mode == "review";
        }
      }
    },
    getLineItemHistoryDataSource(
      CustomerSalesContractCode,
      LineNo,
      filterByCode
    ) {
      var filter = [
        ["CustomerSalesContractCode", "=", CustomerSalesContractCode],
        ["LineNo", "=", LineNo],
      ];

      if (filterByCode) filter.push(["ItemCode", "=", filterByCode]);
      return ApiService.createDataSource("api/CustomerSalesContractLineAudit", {
        sort: [{ selector: "DateCreated", desc: true }],
        filter: filter,
      });
    },
    getSalesContractsInvoicedOrdersListDataSource(CustomerSalesContractCode) {
      return ApiService.createDataSource(
        "api/SalesContractsInvoicedOrdersList",
        {
          sort: [{ selector: "DateIn", desc: true }],
          filter: ["CustomerSalesContractCode", "=", CustomerSalesContractCode],
        }
      );
    },
    getTransactionHistoryDataSource(
      CustomerSalesContractCode,
      LineNo,
      filterByCode
    ) {
      var filter = [
        ["CustomerSalesContractCode", "=", CustomerSalesContractCode],
        ["CustomerSalesContractLineNo", "=", LineNo],
      ];

      if (filterByCode) filter.push(["ItemCode", "=", filterByCode]);

      return ApiService.createDataSource(
        "api/CustomerSalesContractSalesOrderItemConsumption",
        {
          // sort: [{ selector: "SalesOrderCode", desc: false }],
          top: 1000,
          filter: filter,
        }
      );
    },
    itemHistoryPopupHidden() {
      this.$refs["itemHistoryGrid"].instance.clearFilter("row");
      this.lineItemHistoryModel.ItemHistoryDataSourceConfig = [];
    },
    transactionHistoryPopupHidden() {
      this.$refs["transactionHistoryGrid"].instance.clearFilter("row");
      this.transactionHistoryModel.TransactionHistoryDataSourceConfig = undefined;
    },

    popUpBackButtonClick() {
      this.lineItemHistoryPopupVisible = false;
      this.transactionHistoryPopupVisible = false;
    },
    onCloseGenerateModal(refreshData) {
      this.generateSalesOrderPopupVisible = false;
      this.generateSalesOrderFromContractLinePopupVisible = false;
      this.accountStatusPopupVisible = false;

      if (refreshData) {
        this.initialize();
      }
    },
  },
};
</script>
